export default {
	namespaced: true,
	state: {
		newOfferTender: null,
		newStatusTender: null
	},


	mutations: {
		setNewOfferTender(state,newOfferTender) {
			if (!newOfferTender) return
			state.newOfferTender = newOfferTender
		},
		setNewStatusTender(state,newStatusTender) {
			if (!newStatusTender) return
			state.newStatusTender = newStatusTender
		},
	},

	actions: {
		connectToWebsocket({commit, rootState}) {
			const ws = new WebSocket(`wss://${location.host}:8000/ws?userId=${rootState.user.userData.id}`)

			// ws.onopen = function() {
			// 	console.log("Соединение установлено...");
			// };

			ws.onmessage = function(event) {
				let response = JSON.parse(event.data);
				// console.log(response, 'onmessage')
				if(response.action === 'newOfferTender') {
					commit('setNewOfferTender', response.data)
				}
				if(response.action === 'newStatusTender') {
					commit('setNewStatusTender', response.data)
				}
			}
		}
	},

	getters: {
		getNewOfferTender: state => state.newOfferTender,
		getNewStatusTender: state => state.newStatusTender,
	}

}
